import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Checkbox from '@/shared/components/input/Checkbox';
import intlShape from '@/shared/utils/intlShape';
import { StateService } from '@/shared/services/StateService';
import EditableDatePicker from '@/shared/components/editable/EditableDatePicker';
import DocumentsDropdown from '@/shared/components/DocumentsDropdown';
import messages from './trainingMessages';
import FormattedListValue, { listItemMsg } from '@/shared/components/FormattedListValue';
import { FaRegClock, FaSearch } from 'react-icons/fa';
import { LinkIcon, CircleCheckIcon } from '@/shared/components/Icons';
import TrainingCertificateMissingIcon from './TrainingCertificateMissingIcon';
import TrainingEndDateIcon from './TrainingEndDateIcon';

const TrainingEmployeeOverviewRow = ({
  training,
  intl,
  stateService,
  handleSelect,
  onAddRegistrationClick,
  onOpenEmployeeTrainingDetailsClick,
  onMarkAsCompleteClick,
  onUpdateCompletedDate,
  onDocumentUploaded,
}) => {
  return (
    <tbody className="hover" key={training.Id} id={`RowID${training.Id}`}>
      <tr>
        <td>
          <Checkbox onClick={() => handleSelect(training)} value={training.selected} />
        </td>
        <td>
          <a
            title={intl.formatMessage(messages.OpenTrainingDetails)}
            onClick={() => {
              onOpenEmployeeTrainingDetailsClick(training);
            }}
          >
            <b>{training.trainingName}</b>
          </a>
        </td>
        <td>
          <td>{training.description}</td>
        </td>
        <td>
          <FormattedListValue list="trainingStatus" id={training.trainingEmployeeStatus} />
          {training.trainingEmployeeStatus != null &&
            training.trainingEmployeeStatus !== 2 &&
            training.trainingEmployeeStatus !== 3 && (
              <span className="margin5L">
                <TrainingEndDateIcon id={training.id} endDate={training.trainingEndDate} />
              </span>
            )}
        </td>
        <td>
          <FormattedListValue list="trainingType" id={training.type} />
        </td>
        <td>
          <i
            className={`fa ${training.mandatory ? 'fa-check text-success' : 'fa-times text-muted'}`}
          />
        </td>
        <td>
          <i
            className={`fa ${
              training.certificateRequired ? 'fa-check text-success' : 'fa-times text-muted'
            }`}
          />
          {training.trainingEmployeeStatus === 2 && training.certificateMissing && (
            <span className="margin5L">
              <TrainingCertificateMissingIcon id={training.id} />
            </span>
          )}
        </td>
        <td>{training.trainingDurationHours}</td>
        <td>{training.trainingEmployeeDurationMinutes.minuteToTime()}</td>
        <td>{intl.formatDate(training.trainingStartDate)}</td>
        <td>{intl.formatDate(training.trainingEndDate)}</td>
        <td>
          {training.trainingEmployeeStatus === 2 ? (
            <EditableDatePicker
              showClearDate={false}
              value={
                typeof training.completedDate === 'string'
                  ? moment.utc(training.completedDate)
                  : training.completedDate
              }
              onChange={completedDate => onUpdateCompletedDate(training, completedDate)}
            />
          ) : (
            training.completedDate && intl.formatDate(training.completedDate)
          )}
        </td>
        <td className="text-right">
          {training.trainingEmployeeStatus !== 3 && (
            <a
              className={`btn btn-xs btn-icon margin5R${
                training.trainingStatus === 2 || training.trainingStatus === 3 ? ' disabled' : ''
              }`}
              style={
                training.trainingStatus === 2 || training.trainingStatus === 3
                  ? { pointerEvents: 'auto' }
                  : undefined
              }
              title={intl.formatMessage(
                training.trainingStatus === 2
                  ? messages.TrainingClosed
                  : training.trainingStatus === 3
                  ? messages.TrainingCancelled
                  : messages.AddRegistration,
              )}
              onClick={() => {
                if (training.trainingStatus !== 2 && training.trainingStatus !== 3) {
                  onAddRegistrationClick(training);
                }
              }}
            >
              <FaRegClock />
            </a>
          )}
          {training.trainingEmployeeStatus != null &&
            training.trainingEmployeeStatus !== 2 &&
            training.trainingEmployeeStatus !== 3 && (
              <a
                className="btn btn-xs btn-icon margin5R"
                title={intl.formatMessage(messages.MarkAsComplete)}
                onClick={() => onMarkAsCompleteClick(training)}
              >
                <CircleCheckIcon />
              </a>
            )}
          <a
            className="btn btn-xs btn-icon margin5R"
            title={intl.formatMessage(messages.OpenRegistrationOverview)}
            onClick={() =>
              stateService.gotoRegistrationOverview({
                userId: training.userId,
                trainingId: training.trainingId,
                period: 'all',
              })
            }
          >
            <LinkIcon />
          </a>
          <a
            className="btn btn-xs btn-icon margin5R"
            title={intl.formatMessage(messages.OpenTrainingDetails)}
            onClick={() => {
              onOpenEmployeeTrainingDetailsClick(training);
            }}
          >
            <FaSearch />
          </a>
          <DocumentsDropdown
            className="btn-icon margin5R"
            linkId={training.id}
            linkType={13}
            documentType={100000}
            informQueues={false}
            downloadOnClick
            bypassPermissionsForTrainingCertificate
            onUploadComplete={onDocumentUploaded}
          />
        </td>
      </tr>
    </tbody>
  );
};

TrainingEmployeeOverviewRow.propTypes = {
  intl: intlShape.isRequired,
  training: PropTypes.object.isRequired,
  handleSelect: PropTypes.func.isRequired,
  stateService: PropTypes.instanceOf(StateService).isRequired,
  onAddRegistrationClick: PropTypes.func,
  onOpenEmployeeTrainingDetailsClick: PropTypes.func,
  onMarkAsCompleteClick: PropTypes.func.isRequired,
  onUpdateCompletedDate: PropTypes.func.isRequired,
  onDocumentUploaded: PropTypes.func,
};

export default TrainingEmployeeOverviewRow;
